module.exports = __webpack_public_path__ + "static/media/A.852b74fc.png";